export const prefixObjectKeys = (object: { [key: string]: string }, prefix = 'tf_'): { [key: string]: string } => {
	const mappedObject: { [key: string]: string } = {};

	Object.keys(object).forEach((key) => {
		mappedObject[`${prefix}${String(key)}`] = String(object[key]);
	});

	return mappedObject;
};
